import { List } from 'rsuite'
import { BsX } from 'react-icons/bs'
import styles from './searchByKeywordHistory.module.scss'

const SearchByKeywordHistory = ({ history, onSelect, onRemove, onClearAll, t }) => {
  return (
    <div className={styles.searchHistoryDropdown}>
      <List bordered hover>
        {history.map((item, idx) => (
          <List.Item key={item + idx} className={styles.searchHistoryItemRow}>
            <span
              role="button"
              tabIndex={0}
              className={styles.searchHistoryKeyword}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onSelect(item)
                }
              }}
              onClick={e => {
                e.preventDefault()
                onSelect(item)
              }}
              aria-label={`Search for ${item}`}
            >
              {item}
            </span>
            <span
              role="button"
              tabIndex={0}
              className={styles.searchHistoryRemoveBtn}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onRemove(idx)
                }
              }}
              onClick={e => {
                e.preventDefault()
                onRemove(idx)
              }}
              aria-label={`Remove ${item} from history`}
              title={t('search_remove_from_history', 'Remove from history')}
            >
              <BsX size={14} />
            </span>
          </List.Item>
        ))}
      </List>
      <div className={styles.searchHistoryClearAllRow}>
        <button
          type="button"
          className={styles.searchHistoryClearAllBtn}
          onClick={e => {
            e.preventDefault()
            onClearAll()
          }}
          title={t('search_clear_all_history', 'Clear all history')}
          aria-label={t('search_clear_all_history', 'Clear all history')}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onClearAll()
            }
          }}
        >
          {t('search_clear_all', 'Clear All')}
        </button>
      </div>
    </div>
  )
}

export default SearchByKeywordHistory
